namespace GeniuzPOS.ReportMasterData {
    export interface Report_1402Form {
    }

    export class Report_1402Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1402';
    }
}
